/* Tab switcher between listview and mapview in filterbar */
var listView = document.querySelector('#listView');
var mapView = document.querySelector('#mapView');
var listViewBtn = document.querySelector('#listViewBtn');
var mapViewBtn = document.querySelector('#mapViewBtn');

if (mapViewBtn) {
    mapViewBtn.addEventListener('click', function() {
        listView.classList.toggle('is-active');
        mapView.classList.toggle('is-active');
        listViewBtn.classList.toggle('is-active');
        mapViewBtn.classList.toggle('is-active');
    });
}

if (listViewBtn) {
    listViewBtn.addEventListener('click', function() {
        listView.classList.toggle('is-active');
        mapView.classList.toggle('is-active');
        listViewBtn.classList.toggle('is-active');
        mapViewBtn.classList.toggle('is-active');
    });
}
